import { render, staticRenderFns } from "./TopicLay.vue?vue&type=template&id=263a72fb&scoped=true&"
import script from "./TopicLay.vue?vue&type=script&lang=js&"
export * from "./TopicLay.vue?vue&type=script&lang=js&"
import style0 from "./TopicLay.vue?vue&type=style&index=0&id=263a72fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263a72fb",
  null
  
)

export default component.exports